// src/lib/searchCourse.js
// Thin client for /.netlify/functions/search-course. Mirrors golfapi.js:
// attaches a Bearer token from the current Supabase session so the server
// can attribute provider_request_log rows to the calling player (F-091-T1).
// Unauth callers omit the header; server logs requested_by=NULL.
//
// Callers pass either { q } (search by name, min 2 chars enforced server-side)
// or { id } (fetch one course, triggers detail-on-select). Returns parsed
// JSON; throws on non-2xx with a useful message.

import { supabase } from './supabase'

export async function searchCourse(params = {}) {
  const qp = new URLSearchParams()
  if (params.q != null) qp.set('q', params.q)
  if (params.id != null) qp.set('id', params.id)
  const url = `/.netlify/functions/search-course?${qp.toString()}`
  const headers = {}
  try {
    const { data: { session } = {} } = await supabase.auth.getSession()
    if (session?.access_token) headers.Authorization = `Bearer ${session.access_token}`
  } catch { /* no session → send unauthed, server logs NULL */ }
  const res = await fetch(url, { headers })
  const json = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(json.error || `search-course ${res.status}`)
  return json
}
